import { Injectable } from '@angular/core';
import { Party } from '@shared/party';
import { Location } from '@shared/location/models';
import { Features } from '@shared/account/models';
import { IParty } from '@tablesready/common-ui';
import { Observable, Subject } from 'rxjs';

export interface OpenChatPartyModalPayload {
  party: Party | IParty;
  location: Location;
  features: Features;
  editPartyMethod?: (party: Party) => void;
  readOnly?: boolean;
  /** False on plans without 1:1 chat — the compose form still renders, sending upsells instead. */
  canSendChat?: boolean;
  onUpgradeNeeded?: () => void;
  showPartyInfo?: boolean;
}

@Injectable({ providedIn: 'root' })
export class ChatPartyService {
  openChat$: Observable<OpenChatPartyModalPayload>;
  closeChat$: Observable<void>;
  private readonly openChatSource$ = new Subject<OpenChatPartyModalPayload>();
  private readonly closeChatSource$ = new Subject<void>();

  constructor() {
    this.openChat$ = this.openChatSource$.asObservable();
    this.closeChat$ = this.closeChatSource$.asObservable();
  }

  close(): void {
    this.closeChatSource$.next();
  }

  open(
    party: Party | IParty,
    location: Location,
    features: Features,
    editPartyMethod?: (p: Party) => void,
    readOnly?: boolean,
    canSendChat = true,
    onUpgradeNeeded?: () => void,
  ): void {
    this.openChatSource$.next({
      party,
      location,
      features,
      editPartyMethod,
      readOnly,
      canSendChat,
      onUpgradeNeeded,
    });
  }
}
